import { VotingConstants } from "../../constants/voting.constants";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import { message } from "antd";

const uri = "/Voting";

export const getVotingResult = (votingId) => async (dispatch) => {
	try {
		dispatch({ type: VotingConstants.GET_VOTING_RESULTS });
		const response = await client.get(`${uri}/result`, {
			params: { VotingId: votingId },
			headers: authHeader(),
		});
		dispatch({
			type: VotingConstants.GET_VOTING_RESULTS_SUCCESS,
			payload: response.data.sort((result1, result2) => {
				if (result2.itemText === "Другое")
					return result2.itemId - result1.itemId;
			}),
		});
	} catch (e) {
		console.error(e);
		message.error(
			"Не получилось загрузить результаты опроса, попробуйте позже"
		);
	}
};

export const getOtherResults = (results) => async (dispatch) => {
	try {
		const res = {};
		dispatch({ type: VotingConstants.GET_VOTING_OTHER_RESULTS });
		await Promise.all(
			results.map(async (result) => {
				const response = await client.get(`${uri}/other_result`, {
					params: {
						votingId: result.votingId,
						questionId: result.questionId,
						itemId: result.itemId,
					},
					headers: authHeader(),
				});
				res[result.itemId] = response.data;
			})
		);
		dispatch({
			type: VotingConstants.GET_VOTING_OTHER_RESULTS_SUCCESS,
			payload: res,
		});
	} catch (e) {
		console.error(e);
		message.error("Не получилось загрузить ответы, попробуйте позже");
	}
};
